export default {
  orderStatus: {
    0: '您提交了订单，请等待采购员接单',
    23: '采购已接单，正在和商家沟通',
    22: '您的商品已经订购，交易单号：',
    5: '商家已经发货，发货方式：',
    10: '您的商品已经到达acbuy指定仓库',
    16: '您已提交退货申请，请等待采购员处理',
    17: '您已提交换货申请，请等待采购员处理',
    buyerReturn: '采购因客户需求、商品风险等已协助提交退货申请，请耐心等待处理结果',
    buyerReplace: '采购因客户需求、商品风险等已协助提交换货申请，请耐心等待处理结果',
    20: '该订单已经完成退货，',
    beenReturned: ' 查看退款 >',
    30: '您的商品已经寄送，查看所在包裹：',
    43: '您的退货申请取消',
    44: '您的换货申请取消',
    49: '用户未续费存储服务，默认放弃商品',
  },
  expressNo: '物流单号：',
}
